import { imageNames } from "@/src/constants/imageConstants.js";
import imagePath from "@/src/paths/imagePath.js";
import MeetingTalktime from "@/src/views/meetings/conversational_intelligence/recordings/MeetingTalktime.vue";
import MeetingTranscript from "@/src/views/meetings/conversational_intelligence/recordings/MeetingTranscript.vue";

export const recordingTabs = [
  {
    id: "talktime",
    title: "Talktime",
    component: MeetingTalktime,
    selected: imageNames.MEETINGS_TALKTIME_SELECTED,
    unselected: imageNames.MEETINGS_TALKTIME_UNSELECTED,
  },
  {
    id: "transcript",
    title: "Transcript",
    component: MeetingTranscript,
    selected: imageNames.MEETINGS_TRANSCRIPT_SELECTED,
    unselected: imageNames.MEETINGS_TRANSCRIPT_UNSELECTED,
  },
];

export const meetingRecorderAppsIconMapping = {
  google_meet: imagePath.neutral.integration.googleMeet,
  zoom: imagePath.neutral.integration.zoom,
  ms_teams: imagePath.neutral.integration.msTeams,
};

export const meetingRecorderAppsEnabledMapping = {
  google_meet: true,
  zoom: false,
  ms_teams: true,
};

export const meetingSummaryBlockTypes = {
  TEXT: "text",
  LIST: "list",
};
